import React, {
  createContext,
  FC,
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from 'react';
import { useLegoland } from '../LegolandContext';
import { AuthApiClient, createAuthApiClient } from './authApiClient';
import { createUninitializedApiClient } from '../apiClientUtils';

const uninitializedClient = createUninitializedApiClient<AuthApiClient>('Auth');

const AuthApiClientContext = createContext<AuthApiClient>(uninitializedClient);

export const AuthApiClientConsumer = AuthApiClientContext.Consumer;

export function useAuthApiClient() {
  return useContext(AuthApiClientContext);
}

export const AuthApiClientProvider: FC<PropsWithChildren<{}>> = ({
  children,
}) => {
  const { authApiUrl } = useLegoland();
  const [client, setClient] = useState<AuthApiClient | undefined>();

  useEffect(function onMountEffect() {
    setClient(createAuthApiClient({ baseUrl: authApiUrl }));
  }, []);

  if (!client) return null;
  return (
    <AuthApiClientContext.Provider value={client}>
      {children}
    </AuthApiClientContext.Provider>
  );
};
